import React from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const DeleteRoleModal = observer(() => {
    const {modalStore, generalStore, projectStore} = useStores();

    function closeModal() {
        modalStore.resetModalData();
        modalStore.isDeleteRoleDialogOpen = false;
    }

    async function deleteRole() {
        try {
            generalStore.isLoaderOpen = true;
            await projectStore.refreshProjectDetails();
            closeModal();
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('problemDeletingRole'));
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isDeleteRoleDialogOpen'
            className='delete-dialog'
            onEnter={null}
            title={generalStore.translate('deleteRole')}
            body={
                <React.Fragment>
                    <div className="dialog-description">{generalStore.translate('deleteRoleConfirmSentence1')}</div>
                    <br/>
                    <div className="dialog-description">{generalStore.translate('deleteRoleConfirmSentence2')}</div>
                </React.Fragment>
            }
            isConfirmDisabled={false}
            onConfirm={deleteRole}
            confirmText={generalStore.translate('delete')}
        />
    );
});

export default DeleteRoleModal;
